(function($){

    // only if fixed-bg is set from the start
    if ( $('#wrapper-navbar nav').hasClass('no-bg') ) {

        function fadeNavBg() {
            if ($(document).scrollTop() > 100) {
                $("#wrapper-navbar nav").removeClass("no-bg");
            } else {
                $("#wrapper-navbar nav").addClass("no-bg");
            }
        }
        fadeNavBg();

        $(window).on('scroll', function(){
            fadeNavBg();
        });

    }


        // $('.second-header #main-menu > .menu-item-has-children').click(function(e) {
        //     return false;
        // });

        $('.second-header .menu-item-has-children a').click(function(e) {
            e.stopPropagation();
        });




})(jQuery);